import React from 'react';
import DateTime from 'react-datetime';
import * as Formatting from 'fw/misc/Formatting'
import * as Parsing from 'fw/misc/Parsing'
import Moment from 'moment';

class DatePicker extends React.Component {
	constructor(props) {
		super(props);

		this.state = {
			value: this._format(props.value),
			display: this._format(props.value),
			classList: ""
		};
	}

	// Public API
	setValue = (value) => {
		this._update(value);
	}

	getValue = () => {
		return this.state.value;
	}

	focus = () => {
		this._input.focus();
	}

	select = () => {
		this._input.select();
	}

	flag = (status) => {
		if (!status)
			this.setState({ classList: "invalid-field " });
		else
			this.setState({ classList: "" });
	}

	register = () => {
		const requiredPassed = this.completed(this.state.value);
		const validationPassed = (this.validate(this.state.value) === null);
		const status = requiredPassed && validationPassed;

		// Show error status if neccesary
		this.flag(status);
	}

	validate = () => {
        if (this.state.value === "")
            return !this.props.required ? null : "Please select a date";
            
		var date = Moment(this.state.value, ["D MMM YYYY", "DD MMM YYYY"], true);
        return date.isValid() ? null : "Invalid date.";
	}

	completed = (value) => {
		return !((value === "" || value === null) && this.props.required)
	}

	// Events
	onDirt = (e) => {
		this.props.onDirt && this.props.onDirt();
	}

	onChange = (value, display) => {
		this.props.onChange && this.props.onChange(value, display);
	}

	// Private
	_format = (value) => {
		return Formatting.formatDate(value);
	}

	_parse = (value) => {
		return Parsing.parseDate(value);
	}

	_className = () => {
		if (this.props.className !== undefined)
			return this.props.className;
		else
			return "";
	}

	_update = (value, userTyping) => {
		const me = this;
		
		// value = "1234" --> The one that's on the control state (e.g. user input)
		// parsed = 1234.00 --> It's the one that goes to the form state
		// display = "1,234.00" --> what's displayed on the control
		let parsed = value;
		let display = value;

		// Prevent any formatting while typing
		if (userTyping !== true) {
			parsed = this._parse(value);
			display = this._format(value);
		}

		this.setState({ value, display }, function () {
			const requiredPassed = this.completed(value);
			const validationPassed = (this.validate(value) === null);
			const status = requiredPassed && validationPassed;

			// Show error status if neccesary
			this.flag(status);
			
			me.onDirt();

			// If managed by forms, trigger field change, then change
			if (this.props.managed)
				this.props.onFieldChange(parsed, this.props.name, function () { me.onChange(value, display); });
			else
				// If not, only trigger this comp change
				this.onChange(value, display);
		});
	}

	_handleChange = (value) => {
		// If it's a moment object, the user selected a date from the calendar,
		// so we updae every property of the control
		if (value._isAMomentObject) {
			this._update(this._format(value));
		}
		else {
			this._update(value, true);
		}

		// Mark as dirty
		this.props.onDirt && this.props.onDirt();
	}

	_handleInputChange = (e) => {
		this._update(e.target.value, true);
	}

	_handleInputKeyDown = (e) => {
		this.props.onDirt && this.props.onDirt();
	}

	// React
	componentWillReceiveProps(nextProps) {
		// This wouldn't fire on user input, as the next props (coming from the form)
		// would be the same as the state value (that was updated previously on _update)
		// if (nextProps.value !== this.state.value) {
		// 	this.setState({
		// 		value: this._parse(nextProps.value),
		// 		display: this._format(nextProps.value),
		// 		validate: nextProps.validate || true
		// 	});
		// }
	}

	shouldComponentUpdate(nextProps, nextState) {
		return (
			nextState.value !== this.state.value
			|| nextState.display !== this.state.display
			|| nextState.disabled !== this.state.disabled
			|| nextState.classList !== this.state.classList);
	}

	render() {
		const inputProps = {
			name: this.props.name,
			onKeyDown: this._handleInputKeyDown,
			onChange: this._handleInputChange,
			autoComplete: "off",
			className: "form-control " + this.state.classList + " " + this._className(),
			placeholder: this.props.placeholder,
			disabled: this.props.disabled || false,
			style: { padding: "11px" }
		};

		const props = {
			locale: this.props.locale,
			value: this.state.display,
			closeOnSelect: this.props.closeOnSelect,
			closeOnTab: this.props.closeOnTab,
			onChange: this._handleChange,
			onBlur: this.props.onBlur,
			timeFormat: false,
			isValidDate: this.props.isValidDate || function (x) { return true; }
		};
		
		return (<DateTime input={true} {...props} inputProps={inputProps} ref={(c) => { this.picker = c; }} />)
	}
}

DatePicker.defaultProps = {
	formControl: true,
	managed: false,
	closeOnBlur: true,
	closeOnSelect: true,
	closeOnTab: true,
	locale: "en"
};

export default DatePicker;



// WEBPACK FOOTER //
// ./src/fw/forms/controls/datePicker/DatePicker.js